// extracted by mini-css-extract-plugin
export default {"base-form":"BaseForm_base-form__CpOsh"};